import { PIAPI } from '@core/base';
import { CreateTaskRequest, TaskResponse } from '@core/types';
import { Wanx } from './types';

export class WanxAPI extends PIAPI {
  private config: Wanx.Config;
  private static readonly MODEL_NAME = 'Qubico/wanx';

  constructor(apiKey: string, config: Wanx.Config = {}, baseUrl?: string) {
    super(apiKey, baseUrl);
    this.config = config;
  }

  private createWanxRequest(
    taskType: Wanx.TaskType,
    params: Wanx.TextToVideoParams | Wanx.ImageToVideoParams
  ): CreateTaskRequest {
    this.logger.debug('Creating Wanx request with params:', params);

    const request: CreateTaskRequest = {
      model: WanxAPI.MODEL_NAME,
      task_type: taskType,
      input: {
        ...params,
      },
    };

    // Add webhook configuration if provided
    if (this.config.webhookUrl && this.config.webhookSecret) {
      request.config = {
        webhook_config: {
          endpoint: this.config.webhookUrl,
          secret: this.config.webhookSecret,
        },
      };
    }

    return request;
  }

  async textToVideo(
    params: Wanx.TextToVideoParams,
    modelSize: '1.3b' | '14b' = '14b'
  ): Promise<TaskResponse<Wanx.VideoTaskOutput>> {
    this.logger.info('Starting Wanx text-to-video generation', { prompt: params.prompt });
    
    const taskType: Wanx.TaskType = modelSize === '1.3b' ? 'txt2video-1.3b' : 'txt2video-14b';
    const request = this.createWanxRequest(taskType, params);
    
    return this.createTask<Wanx.VideoTaskOutput>(request);
  }

  async imageToVideo(
    params: Wanx.ImageToVideoParams
  ): Promise<TaskResponse<Wanx.VideoTaskOutput>> {
    this.logger.info('Starting Wanx image-to-video generation', { prompt: params.prompt, image: params.image });
    
    if (!params.image) {
      throw new Error('Image URL is required for image-to-video generation');
    }
    
    const request = this.createWanxRequest('img2video-14b', params);
    
    return this.createTask<Wanx.VideoTaskOutput>(request);
  }

  async getVideoTask(taskId: string): Promise<TaskResponse<Wanx.VideoTaskOutput>> {
    return this.getTask<Wanx.VideoTaskOutput>(taskId);
  }
} 